import { convexQuery } from '@convex-dev/react-query';
import { api } from '@repo/backend/_generated/api';
import { createFileRoute } from '@tanstack/react-router';
import { CampaignDetail } from '@/features/campaigns/campaign-page';

export const Route = createFileRoute('/_authenticated/campaigns/$id/')({
    head: () => ({ meta: [{ title: 'Campaign | promote.fun' }] }),
    loader: async ({ context, params }) => {
        await context.queryClient.ensureQueryData(convexQuery(api.campaigns.getCampaignBySlugOrId, { slugOrId: params.id }));
    },
    component: CampaignDetail,
});
